var lx = lx || {};
lx.roster = {
    data: {},
    empData: [],
    templ: {},
    shiftDD: "",
    shiftAdd: false,
    outId: 0,
	rptOutId: 0,
	rptSearch: "",
    signRequestDetails: {},
    loc: {},
    docId: null,
    setEmpData: (empId, docs, pRefresh) => {
        let dates = {};
        let documents = [];
        docs.forEach(d => {
            documents.push({"id":d.id,"docNo":d.docNo,"adtId":d.adtId,"adtCode":d.adtCode,"type":d.type,"typeId":d.typeId,"status":d.status,"sign":d.sign});
            if (d.adtCode == 'VLR' && (d.type == 'S' || d.type == 'D') ){
                let r = d.rows[0];
                if (!dates[r.dateId]) dates[r.dateId] = [];
                dates[r.dateId].push({"id":d.id,"rsrId":d.rsrId,"adtCode":d.adtCode,"type":d.type,"typeId":d.typeId,"rId":r.id,
                                "stId":r.stId,"stSplit":r.stSplit,"start":r.start,"end":r.end,
                                "stIdA": r.stIdA,"startA":r.startA,"endA":r.endA,"deleteReq":r.deleteReq,
                                "confirmedBy": (d.sign == 0 && (!r.confirmedBy || r.confirmedBy != lx.roster.data.cpidFol) ? null : r.confirmedBy),
                                "repeat": (d.rows.length > 1 ? d.rows.length : null), "detachedTo": d.detachedTo });
            } else {
                d.rows.forEach(r => {
                    if (!dates[r.dateId]) dates[r.dateId] = [];
                    dates[r.dateId].push({"id":d.id,"rsrId":d.rsrId,"adtCode":d.adtCode,"type":d.type,"typeId":d.typeId,"rId":r.id,
                                "stId":r.stId,"stSplit":r.stSplit,"start":r.start,"end":r.end,
                                "stIdA": r.stIdA,"startA":r.startA,"endA":r.endA,"deleteReq": r.deleteReq,
                                "confirmedBy": (d.sign == 0 && (!r.confirmedBy || r.confirmedBy != lx.roster.data.cpidFol) ? null : r.confirmedBy),
                                "workFrom": r.workFrom });
                });
            }
        });
        if (pRefresh) {
            let emp = lx.roster.empData.filter( (e) => e.id == empId);
            if (emp.length == 0) {
                emp = {"id":empId};
                lx.roster.empData.push(emp);
            } else emp = emp[0];
            emp.dates = dates;
            emp.docs  = documents;
            lx.roster.setData(emp);
        } else {
            lx.roster.empData.push({"id":empId,"dates":dates,"docs":documents});
        }
    },
    refreshEmp: (empId) => {
        apex.server.process('refreshEmp', {x01: empId, x02: lx.roster.data.id},{
            type: "GET",
            dataType: "json",
            success: (d) => {
                if (d) lx.roster.setEmpData(d.id, d.docs, true);
            }
        });
    },
    setView: (pThis) => {
        let tab = $(pThis).attr("aria-controls");
        let $r = $("#roster");
        if (tab == 'all') {
            $r.addClass("showHours showShifts");
        } else if (tab == 'days') {
            $r.removeClass("showHours showShifts");
        } else if (tab == 'shifts') {
            $r.removeClass("showHours").addClass("showShifts");
        } else if (tab == 'hours') {
            $r.removeClass("showShifts").addClass("showHours");
        }
        $(".a-Tabs-selected.is-active").removeClass("a-Tabs-selected is-active");
        $(pThis).addClass("a-Tabs-selected is-active");
    },
    renderDep: (deps, bredcrumb, renderDepDD) => {
        let depsHtml = '';
        let depsEmpCnt = 0;
        let depDD = '';
        for (let i = 0; i < deps.length; i++) {
            let depHtml = '';
            let depHtmlSub = '';
            let subDep = {html:null,empCnt:0,depDD:""};
            let empCnt = 0;
            let empCntSub = 0;
            const dep = deps[i];
            if (dep.deps.length == 0 && dep.emps.length == 0) continue;
            const color = (dep.color ? ' style="border-top: 4px solid '+ dep.color +'"' : '');//50
            if (!lx.roster.data.documentView)
                depHtml += '<tr class="dep" data-id="'+ dep.id +'"><td'+ color +'colspan="'+ (lx.roster.templ.dep+4) +'">'+ 
                        //'<i class="fas fawe-'+ (dep.lvl == 1 && dep.id != 0 ? 'home-alt' : 'folder-open') + '"></i> '+
                        //"-".repeat(dep.lvl-1)+
                        (dep.name ? (bredcrumb && bredcrumb.length > 0 ? '<div class="breadcrumb">'+
                                                                            (bredcrumb.length > 3 ? '<span class="ext hidden">'+ bredcrumb.slice(0, -3).join(' > ') +' > </span>' : '') + 
                                                                            bredcrumb.slice(-3).join(' > ') +
                                                                            (bredcrumb.length > 3 ? '<i class="fas fawe-expand-alt" onclick="$(this).siblings(\'.ext\').toggleClass(\'hidden\');"></i>' : '') +
                                                                          '</div>' : '') + 
                                                                          dep.name : 
                                    'Unnamed Department') +'</td>'+ 
                        //tmpl.replaceAll('#ONCLICK#', '').replaceAll("#ID#", "D"+dep.id) +
                        //lx.roster.templ.dep +
                        '</tr>';
            for (let j = 0; j < dep.emps.length; j++) {
                const emp = dep.emps[j];
                const editable = dep.mgr || emp.id == lx.roster.data.cpidFol && (emp.eTs || emp.eVlr || emp.eOh);
                let actions = [];
                if (editable) {
                    actions.push({"label":lx.tran.get('CLEAR_ALL'),"js":"lx.roster.shiftRemoveAll(this);"});
                    //actions.push({"label":"Create Document","js":"lx.roster.documentForm(this);"});
                    if (dep.mgr) {
                        actions.push({"label":lx.tran.get('APPROVE_ALL'),"js":"lx.roster.shiftApproveAll(this);"});
                    } else {
                        actions.push({"label":lx.tran.get('SEND_APPROVAL'),"js":"lx.roster.sendToSig(this);"});
                        lx.roster.signRequestDetails = emp.signRequestDetails;
                    }
                    if (lx.roster.data.editEmp) actions.push({"label":lx.tran.get('EDIT_EMP'),"js":"lx.roster.editEmp(this);"});
                }
                let days = lx.roster.templ.emp.slice();
                if (emp.disableDays.length > 0) {
                    for (const x in emp.disableDays) {
                        const dayid = emp.disableDays[x];
                        days = days.replace('class="rsrOffDay" id="#ID#_'+ dayid +'" data-date="'+ emp.disableDays[x], 'class="disabled').replace('id="#ID#_'+ dayid +'" data-date="'+ emp.disableDays[x], 'class="disabled');
                    }
                }
                depHtml += '<tr class="emp '+ (editable ? ' editable' : '') + (dep.mgr ? ' confirmable' : '') + (emp.eTs ? ' eTS' : '') + (emp.eVlr ? ' eVLR' : '') + (emp.eOh ? ' eOH' : '') + 
                                '" data-id="'+ emp.id +'" data-workhrsday="'+ emp.workHrsDay +'">'+
                        (lx.roster.data.documentView ? '' :
                            '<td><div>'+ //'+ color +'
                                '<div class="img">'+ lx.profile.genPic(emp.img) +'</div>'+
                                '<div class="txt">'+
                                    '<div class="name">'+ (emp.rank ? emp.rank+' ' : '') + (emp.name ? emp.name : '') +'</div>'+
                                    (emp.wp ? '<div class="wp">'+ emp.wp +'</div>' : '')+
                                    (emp.lastUpdate ? '<div class="updated"><i class="far fawe-clock" style="font-size:1.2rem;"></i> '+ emp.lastUpdate +'</div>' : '')+
                                '</div><div class="right">'+
                                    (actions.length > 0 ? lx.btn.gen({"class":"t-Button--dd-noBorder","options":actions}) : '')+
                                '<div class="docs"></div></div></div></td>')+ 
                                days.replaceAll("#ID#", "D"+emp.id) + 
                                '<td class="total"><p class="ts">0</p><p class="of">'+ lx.tran.get("OF") +'<br />'+ (emp.workHrsDay * (lx.roster.templ.dep - emp.disableDays.length)) +'</p></td>'+
                                '<td class="total"><p class="vlr">0</p></td>'+
                                '<td class="total"><p class="oh">0</p></td>'+
                                '</tr>';
                // push documents to central array
                //console.log(emp.docs);
                if (emp.docs.length > 0) lx.roster.setEmpData(emp.id, emp.docs, false);
                empCnt++;
            }
            if (dep.deps.length > 0) {
                let lBredcrumb = (bredcrumb ? [...bredcrumb] : []);
                lBredcrumb.push(dep.name);
                subDep = lx.roster.renderDep(dep.deps, lBredcrumb /*(bredcrumb ? bredcrumb : '') + dep.name +' > '*/, renderDepDD);
            }
            if (renderDepDD) depDD += '<tr'+ (lx.roster.outId == dep.id ? ' class="current"' : ' onclick="lx.roster.setOutId('+ dep.id +', this)"') +'><td>'+ 
                                        "-".repeat(dep.lvl-1) + dep.name +'</td><td>'+ empCnt +'</td></tr>'+//<td>'+ (subDep.empCnt > 0 ? (empCnt + subDep.empCnt) : '') +'</td>
                                        subDep.depDD;
            depsHtml += (empCnt > 0 ? depHtml : '') + (subDep.html ? subDep.html : '');
            depsEmpCnt += empCnt + (subDep.empCnt ? subDep.empCnt : 0);
        }
        return {html: depsHtml, empCnt: depsEmpCnt, depDD: depDD};
    },
    render: () => {
        // year dropdown
        let yearDD = "";
        for (let i = 0; i < lx.roster.data.years.length; i++) {
            const y = lx.roster.data.years[i];
            yearDD += '<tr'+ (y.year == lx.roster.data.year ? ' class="current"' : ' onclick="lx.roster.setCycle(\''+ y.date +'\')"') +'><td>'+ y.year +'</td></tr>';
        }
        yearDD = '<div id="yearDD"><table><thead><tr><th>'+lx.tran.get('YEAR')+'</th></tr></thead><tbody>'+
                    yearDD +
                   '<tbody></table></div>';
        // cycle dropdown
        let cycleDD = "";
        let cycleCurrent;
        for (let i = 0; i < lx.roster.data.cycles.length; i++) {
            const c = lx.roster.data.cycles[i];
            cycleDD += '<tr'+ (c.current ? ' class="current"' : ' onclick="lx.roster.setCycle(\''+ c.start +'\')"') +'><td>#'+ c.seq +'</td><td>'+ c.start +'</td><td>'+ c.end +'</td></tr>';
            if (c.current) cycleCurrent = lx.tran.get('CYCLE')+' #'+ c.seq +': '+ c.start +' - '+ c.end;
        }
        cycleDD = '<div id="cycleDD"><table><thead><tr><th>'+lx.tran.get('CYCLE')+'</th><th>'+lx.tran.get('START')+'</th><th>'+lx.tran.get('END')+'</th></tr></thead><tbody>'+
                   cycleDD +
                   '<tbody></table></div>';
        // shift dropdown
        let shifts = "";
        for (let i = 0; i < lx.roster.data.shifts.length; i++) {
            const s = lx.roster.data.shifts[i];
            if (s.visible == 1){
                let cStyle = (s.colorBg ? ' style="background-color:'+ s.colorBg + (s.colorTxt ? ';color:'+ s.colorTxt : '')+'"' : '');
                shifts += '<tr data-id="'+ s.id +'" data-adtcode="'+ s.adtCode +'" data-type="'+ s.type +'" data-oncall="'+ s.onCall+'">'+
                            '<td'+ cStyle +' class="'+ (cStyle ? (s.class ? ' class="lx_hr_type_'+ s.class +'"' : ''):'') +
                            (s.adtCode == 'TS' && s.workFrom != 'N' ?
                                '">'+ s.code +'<i class="workFrom fas fawe-building" title="'+ lx.roster.data.workFrom.W +'"></i></td>'+
                                '<td'+ cStyle +' class="'+ (cStyle ? (s.class ? ' class="lx_hr_type_'+ s.class +'"' : ''):'') +
                                ' home">'+ s.code +'<i class="workFrom fas fawe-home" title="'+ lx.roster.data.workFrom.H +'"></i></td>'
                            : 
                                '" colspan="2">'+ (s.onCall == 'Y' ? '<i class="onCall fas fawe-phone"></i> ' : '') + s.code +'</td>'
                            )+
                            '<td>'+ s.name +'</td>'+
                            '<td>'+ s.desc +'</td>'+
                           '</tr>';
                /*if (s.type == 'M' && lx.roster.data.sickLeave4)
                    shifts += '<tr data-id="'+ s.id +'" data-adtcode="'+ s.adtCode +'">'+
                                '<td'+ (s.colorBg ? ' style="background-color:'+ s.colorBg + (s.colorTxt ? ';color:'+ s.colorTxt : '') +'"' : 
                                                    (s.class ? ' class="lx_hr_type_'+ s.class +'"' : '') ) +' colspan="2">'+ s.code +'</td>'+
                                '<td>'+ s.name +' 4h</td>'+
                                '<td>'+ s.desc +'</td>'+
                               '</tr>';*/
            }
        }
        lx.roster.shiftDD = '<div id="shiftDD"><table><thead><tr><th colspan="2">'+lx.tran.get('ABBR')+'</th><th>'+lx.tran.get('NAME')+'</th><th>'+lx.tran.get('START_END')+'</th></tr></thead><tbody>'+
                            //'<tr data-id="-1" style="display:none"><td colspan="3">Disable Quick Entry</td></tr>'+
                            '<tr data-id="-2"><td colspan="2"></td><td>'+lx.tran.get('CLEAR')+'</td><td></td></tr>'+ shifts +
                            '<tbody></table></div>';

        let html = "";
        let mons = "";
        let dys  = "";
        let days = "";
        let dayCnt = 0;
        // reset templates
        lx.roster.templ = {dep:0,emp:""};
        // render headers
        for (let i = 0; i < lx.roster.data.mons.length; i++) {
            const mon = lx.roster.data.mons[i];
            mons += '<th colspan="'+ mon.days.length +'">'+ mon.name +'</th>';
            for (let j = 0; j < mon.days.length; j++) {
                const day = mon.days[j];
                const css = (day.weekend || day.hol ? ' class="rsrOffDay"' : '');
                //dys  += '<th'+ css +'>'+ day.dy +'</th>';
                days += '<th'+ css +' title="'+ day.text +'">'+ day.day +'<br /><b>'+ day.dy +'</b></th>';
                lx.roster.templ.emp += '<td'+ css +' id="#ID#_'+ day.id +'" data-date="'+ day.id +'"><div class="recs"></div>' +
                                        (day.hol ? '<i class="hol fas fa-star" title="'+ day.hol +'"></i>' : '') +
                                        '</td>';// #ONCLICK#
                lx.roster.templ.dep++;//+= '<td></td>';
                dayCnt++;
            }
        }
        // reset emp data, it will be repopulated with renderDep > setEmpData
        lx.roster.empData = [];
        // render departments and emplyees
        let deps = lx.roster.renderDep(lx.roster.data.deps, null, true);
        // department dropdown
        deps.depDD = '<div id="depDD"><table><thead><tr><th>'+lx.tran.get('DEPARTMENT')+'</th><th>'+lx.tran.get('EMPS')+'</th></tr></thead><tbody>'+//<th>Total</th>
                        '<tr onclick="lx.roster.setOutId(0, this)"><td>'+lx.tran.get('ALL_DEPARTMENTS')+'</td><td>'+ deps.empCnt +'</td></tr>'+
                        deps.depDD +
                      '<tbody></table></div>';
        
        html =  '<div class="rsrHdr">'+
                '<div>'+
                 //(lx.roster.data.documentView ? '' : '<div class="col1">'+lx.tran.get('DEPARTMENTS')+'</div>')+
                 //'<div class="col2">'+
                  '<ul class="t-Tabs t-Tabs--simple a-Tabs" role="tablist" style="white-space: nowrap; overflow-x: hidden;">'+
                   '<li class="t-Tabs-item a-Tabs-after a-Tabs-selected is-active" aria-controls="days" role="presentation" id="SR_days_tab" onclick="lx.roster.setView(this)"><a href="javascript:void(0);" class="t-Tabs-link" role="tab" aria-controls="SR_days" aria-selected="true"><span>'+lx.tran.get('DAYS2')+'</span></a></li>'+
                   '<li class="t-Tabs-item a-Tabs-after" aria-controls="shifts" role="presentation" id="SR_roster_tab" onclick="lx.roster.setView(this)"><a href="javascript:void(0);" class="t-Tabs-link" role="tab" aria-controls="SR_roster"><span>'+lx.tran.get('SHIFTS')+'</span></a></li>'+
                   //'<li class="t-Tabs-item a-Tabs-after" aria-controls="hours" role="presentation" id="SR_hour_tab" onclick="lx.roster.setView(this)"><a href="javascript:void(0);" class="t-Tabs-link" role="tab" aria-controls="SR_hour"><span>Hours</span></a></li>'+
                   //'<li class="t-Tabs-item a-Tabs-after" aria-controls="all" role="presentation" id="SR_all_tab" onclick="lx.roster.setView(this)"><a href="javascript:void(0);" class="t-Tabs-link" role="tab" aria-controls="SR_all"><span>All</span></a></li>'+
                  '</ul>'+
                 //'</div>'+
                '</div>'+
                (lx.roster.data.documentView ? '' :
                '<div class="ddCell">'+
                    '<div class="pillCbx">'+
                    '<div class="info" id="year" onclick="lx.roster.ddYearToggle();">'+ lx.roster.data.year + yearDD +
                        '<i class="iSelect far fawe-chevron-down"></i><i class="iRemove far fawe-times"></i></div>'+
                    '<div class="info" id="cycle" onclick="lx.roster.ddCycleToggle();">' + cycleCurrent + cycleDD +
                        '<i class="iSelect far fawe-chevron-down"></i><i class="iRemove far fawe-times"></i></div>'+
                    '<div class="info ro">'+ lx.roster.data.duration +' '+lx.tran.get('DAY_PASS_LAST')+': '+ lx.roster.data.lastUpdate +'</div>'+
                    '<div id="quickShift" class="info">'+lx.tran.get('QUICK_ENTRY')+'<span></span>'+
                        '<i class="iSelect far fawe-chevron-down"></i><i class="iRemove far fawe-times" onclick="lx.roster.clearQuickShift();"></i></div>'+
                    '</div>'+
                '</div>')+
                '</div>'+
                '<table><thead>'+
                '<tr>'+
                 (lx.roster.data.documentView ? '' :
                    '<th>'+
                    '<div class="searchBox"><input type="text" class="apex-item-text" onkeydown="lx.map.searchKeyDown(event);" onkeyup="lx.roster.search(event);" placeholder="'+lx.tran.get('SEARCH_PEOPLE')+'" style="padding-right: 0.2rem;">'+
                    '</div>'+
                    '</th>')+
                mons +'<th colspan="3" class="total">'+ lx.tran.get('TOTAL_HOURS') +'</th></tr>'+
                '<tr>'+ 
                (lx.roster.data.documentView ? '' :
                    '<th>'+
                        '<div class="info" id="dep" onclick="lx.roster.ddDepToggle()"><span>'+ lx.roster.loc.filterDep +'</span>' + deps.depDD +
                        '<i class="iSelect far fawe-chevron-down"></i><i class="iRemove far fawe-times" onclick="lx.roster.setOutId(0,this);"></i></div>'+
                    '</th>'
                ) +
                days + '<th class="total">'+ lx.tran.get('TS_SHORT') +'</th><th class="total">'+ lx.tran.get('VLR_SHORT') +'</th><th class="total">'+ lx.tran.get('OH_SHORT') +'</th></tr>'+
                //'<tr>'+ dys +'</tr>'+
                '</thead><tbody>'+ deps.html +
                '<tr class="spacerRow"><td></td></tr>' +
                '</tbody></table>';
        $("#roster").html(html);
        lx.roster.setData();
        $(".emp.editable td:not(:first-child)").click( (e) => { if ($(e.target).closest(".editHours").length == 0) lx.roster.ddOpen(e); } );
        $("#quickShift").click((e) => {lx.roster.ddOpen(e, true); e.stopPropagation();});
        let empId = $v('P157_EMP_ID');
        if (empId) $(".emp[data-id="+empId+"]")[0].scrollIntoView(false);
    },
    getShift: (pId, pAdtCode, pType) => {
        if (pId == -2) return {"id":-2,"adtCode":pAdtCode,"code":"CLR","name":"Clear","start":0,"end":60};
        else if (!pId || pId == 0) return {"id":0,"adtCode":pAdtCode,"code":"C","name":"Custom","start":0,"end":60,"workFrom":'N'};
        else if (pType == 'M4') return lx.roster.data.shifts.filter( e => e.adtCode == pAdtCode && e.type == pType)[0];
        return lx.roster.data.shifts.filter( e => e.id == pId && e.adtCode == pAdtCode )[0];
    },
    getShiftFromCode: (pAdtCode, pLeaveType) => {
        if (pAdtCode == 'TS') return {"id":0,"adtCode":pAdtCode,"type":"W","code":"W","name":"Regular Hours","start":0,"end":60};
        return lx.roster.data.shifts.filter( e => e.adtCode == pAdtCode && e.type == pLeaveType)[0];
    },
    docInfo: (pThis) => {
        lx.roster.closeDoc();
        let $rec = $(pThis).closest('.rec');
        lx.roster.docId = $rec.data("docid");
        lx.roster.adtCode = $rec.data("adtcode");
        lx.roster.shiftType = $rec.data("type");
        lx.roster.openDoc(lx.roster.docId);
    },
    closeDoc: () => {
        $('.rec.highlight').removeClass("highlight");
        $('.empDocInfo').remove();
        lx.roster.docId = null;
        lx.roster.adtCode = null;
        lx.roster.shiftType = null;
    },
    openDoc: (pId) => {
        if ($(".resterDoc").length != 0) lx.roster.closeDoc();
        apex.server.process('openHrDoc', {x01: pId},{
            type: "GET",
            dataType: "json",
            success: (d) => {
                //if (d.link) lx.nav.redirect(d.link, pLinkType == 'E');
                let html =  '<div class="rosterDoc">'+
                                '<div class="closeDoc" onclick="lx.roster.closeDoc();"><i class="far fawe-times"></i></div>'+
                                '<div class="row">'+
                                    '<div class="col col-4 apex-col-auto"><label>'+ d.docType +':</label><div class="value"><a href="'+ d.link +'">'+ d.docNum +'</a> ('+ d.status +')</div></div>'+
                                    '<div class="col col-4 apex-col-auto"><label>'+ d.locDocDate +':</label><div class="value">'+ d.docDate +'</div></div>'+
                                    (d.dep ? '<div class="col col-4 apex-col-auto"><label>'+ d.locDep +':</label><div class="value">'+ d.dep +'</div></div>' : '')+
                                '</div>'+
                                d.summary +
                                '<div class="row roles">'+ d.roles +'</div>'+
                                //'<div id="lxComments"></div>'+
                            '</div>';
                let $rec = $('.rec[data-docid='+pId+']');
                $rec.addClass("highlight");
                
                let $emp = $rec.closest(".emp");
                if ($emp.length == 0) $emp = $(".emp[data-id="+ d.empId +"]");
                $emp.after('<tr class="empDocInfo" data-eid="'+ $emp.data("id") +'"><td></td>'+
                            //'<td colspan="'+ Math.floor(lx.roster.data.duration / 2) +'">'+ 
                            '<td colspan="'+ (lx.roster.data.duration + 3) +'">'+ 
                                html +
                            //'</td>'+
                            //'<td colspan="'+ Math.ceil(lx.roster.data.duration / 2) +'">'+ 
                                '<div id="lxComments"></div>' + 
                            '</td>'+
                           '</tr>');
                //lx.dialog.open({id:"hrDoc", maxWidth: "600px", title: d.docType +': '+ d.docNum +' ('+ d.status +')', html: html, close: () => { $('.rec[data-docid='+pId+']').removeClass("highlight"); }});
                lx.comment.init({htmlID: "lxComments",recId: pId, etyId: 55/* HR_FORM */, iusId: null, shared:0});
            }
        });
    },
    sendToSigRow: null,
    sendToSigChoice: null,
    sendToSig: (pThis) => {
        let $tr = $(pThis).closest('tr.emp');
        if ($tr.hasClass("changed")) {
            lx.roster.submit(null, pThis);
            return;
        }
        lx.roster.sendToSigRow = $tr;
        let adtIds = [], docIds = [], docCnt = 0;
        $tr.find('.docs > div').each(function( index ){
            if ($(this).hasClass("statCRE")){
                adtIds.push(this.dataset.adt);
                docIds.push(this.dataset.id);
            }
            docCnt++;
        });
        if (docCnt == 0){
            lx.info.error("No document to submit");
            return;
        } else if (adtIds.length == 0) {
            lx.info.error("Documents already submited!");
            return;
        }
        lx.load.add();
        apex.server.process('sendToSig', {f01: adtIds, f02: docIds},{
            type: "GET",
            dataType: "json",
            success: (d) => {
                lx.load.remove();
                render(d);
            }
        });

        function render(d) {
            let html = "";
            for (let i = 0; i < d.docs.length; i++) {
                const doc = d.docs[i];
                const shift = lx.roster.getShiftFromCode(doc.adtCode, doc.type);
                const minSig = doc.minSig;
                let signSelected = [];
                let signeeLov = '';
                for (let i = 0; i < doc.signeeLov.length; i++) {
                    const emp = doc.signeeLov[i];
                    if (i < minSig) signSelected.push(emp.id);
                    signeeLov += '<option value="'+ emp.id +'">'+ emp.name +'</option>';
                }
                signeeLov = '<select class="selectlist apex-item-select" size="1" multiple>'+ signeeLov + '</select>';//signee 
                let rowHtml = signeeLov;
                if (signSelected.length == 0) {
                    rowHtml = rowHtml.replace('value="'+ doc.signeeLov[0].id +'"', 'value="'+ doc.signeeLov[0].id +'" selected');
                } else {
                    for (let j = 0; j < signSelected.length; j++) {
                        const sig = signSelected[j];
                        rowHtml = rowHtml.replace('value="'+ sig +'"', 'value="'+ sig +'" selected');
                        //console.log(sig);
                        /*rowHtml +=  '<div>'+ signeeLov.replace('value="'+ sig +'"', 'value="'+ sig +'" selected') +
                                    '<i class="fas fawe-times" onclick="lx.roster.sigDel(this);"></i></div>';*/
                    }
                }
                /*if (rowHtml == '') rowHtml += '<div>'+ signeeLov.replace('value="'+ doc.signeeLov[0].id +'"', 'value="'+ doc.signeeLov[0].id +'" selected') +
                                              '<i class="fas fawe-times" onclick="lx.roster.sigDel(this);"></i></div>';*/
                html += '<div class="docSign" data-adt="'+ doc.adtId +'" data-id="'+ doc.id +'"'+ (i>0 ? 'style="display:none"' : '') +'>'+
                            '<div class="docType" title="'+ shift.name +'">'+ shift.code +'</div>'+
                            '<div class="signees">'+ rowHtml + '</div>'+
                            //lx.btn.gen({"fa":"far fawe-plus","js":"lx.roster.sigAdd(this);","class":"t-Button--noLabel"})+
                        '</div>';
            }
            //html += lx.btn.gen({"label":"Send","fa":"far fawe-paper-plane","js":"lx.roster.sigSubmit(this);","class":"t-Button--primary"});
            html = '<div id="sigForm">'+ html + '<textarea id="sigComment" maxlength="4000" class="textarea apex-item-textarea" placeholder="'+ lx.tran.get("NOTE") +'"></textarea>'+'</div>';
            lx.dialog.open({id:"sendToSig", maxWidth: "600px", title: "Send to Authorization", html: html, container: true, 
                            alertMsg: {type:"info",msg:"Select who needs to authorize document."},
                            buttons: [  {"label":"Cancel","fa":"far fawe-paper-times","js":"lx.dialog.close(this);"},
                                        {"label":"Send","fa":"far fawe-paper-plane","js":"lx.roster.sigSubmit(this);","class":"t-Button--primary"}]});
            lx.roster.sendToSigChoice = new Choices('#sigForm select', {removeItemButton:true});
            //$("#sigForm .docSign:nth-child(2) select").select2();
        }
    },
    sigSubmit: (pThis) => {
        let $form = $(pThis).closest(".lxpDialog").find("#sigForm");
        let adtIds = [], docIds = [], sigs = [];
        $form.find(".docSign").each( function (idx) {
            adtIds.push(this.dataset.adt);
            docIds.push(this.dataset.id);
            sigs.push( lx.roster.sendToSigChoice.getValue(true).join(":") );
             /* sigs.push( $(this).find(".signees select").map((idx, el) => {
                 return el.value;
              } ).get().join(":") ); */
        });
        lx.load.add();
        apex.server.process('sendToSigSubmit', {f01: adtIds, f02: docIds, f03: sigs, x01: $v("sigComment")},{
            type: "GET",
            dataType: "json",
            success: (d) => {
                lx.load.remove();
                for (let i = 0; i < d.docs.length; i++) {
                    const doc = d.docs[i];
                    lx.roster.sendToSigRow.find(".docs > div[data-id="+ doc.id +"]").removeClass("statCRE").addClass("statSFS").attr("title","SFS");
                }
                lx.dialog.close(null, "sendToSig")
            }
        });
    },
    sigAdd: (pThis) => {
        let $table = $(pThis).closest('.docSign').find(".signees");
        $table.append( '<div>'+ $table.find(">div:last-child").html() +'</div>');
    },
    sigDel: (pThis) => {
        let $sig = $(pThis).parent();
        if ($sig.parent().find(">div").length > 1) $sig.remove();
    },
    setData: (pEmp) => {
        function setEmp(emp) {
            const $emp = $(".emp[data-id="+ emp.id +"]");
            let workHrs = 0;
            $emp.find(".rec").remove();
            if (Object.keys(emp.dates).length > 0)
                for (const key in emp.dates){
                    const day = emp.dates[key];
                    const $td = $emp.find("td[data-date="+key+"]");
                    for (let k = 0; k < day.length; k++) {
                        const row = day[k];
                        if (row.stSplit != 2) {
                            const shift = lx.roster.getShift( (row.adtCode == 'TS' ? (row.confirmedBy ? row.stIdA : row.stId) : row.typeId), row.adtCode );
                            console.log(row);
                            console.log(shift);
                            lx.roster.shiftSetP( $td, shift, row );
                        }
                    }
                }
            // list docs
            if ($emp.hasClass("editable")){
                let $docs = $emp.find(".docs");
                let manager = $emp.hasClass("confirmable");
                $docs.html("");
                for (let i = 0; i < emp.docs.length; i++) {
                    const doc = emp.docs[i];
                    const shift = lx.roster.getShiftFromCode(doc.adtCode, doc.type);
                    $docs.append('<div class="stat'+ (doc.sign == 1 ? 'SIG' : doc.status) +'" data-adt="'+ doc.adtId +'" data-id="'+ doc.id +'" title="'+ doc.status +'" onclick="lx.roster.openDoc('+ doc.id +')">'+ shift.code +'</div>');
                }
            }
            lx.roster.setHeights($emp);
        }

        if (pEmp) {
            setEmp(pEmp);
        }else{
            for (let i = 0; i < lx.roster.empData.length; i++) {
                setEmp(lx.roster.empData[i]);
            }
        }
    },
    fetch: (pDate) => {
        // localization
        if (!lx.roster.loc.filterDep) lx.roster.loc.filterDep = lx.tran.get('FILTER_DEPTS');
        
        let date = $nvl(pDate, $v("P157_DATE"));
        lx.load.add();
        apex.server.process('rosterFetch', {x01: date, x02: $v("P30_ID")},{
            type: "GET",
            dataType: "json",
            success: (d) => {
                lx.load.remove();
                //console.log(d);
                lx.roster.data = d;
                lx.roster.render();
            }
        });
    },
    search: (e) => {
        let term = e.target.value.toLowerCase();
		lx.roster.rptSearch = term;
        if (term.length = "") {
            $("#roster .emp").show();
		} else {
            $("#roster .emp").each( function () {
                let $box = $(this);
                let name = $box.find(".name").text().toLowerCase();
                let tags = $box.find(".wp").text().toLowerCase();
                //let address = $box.find(".address").text().toLowerCase();
                if (name.includes(term) || tags.includes(term) /*|| address.includes(term)*/ ) $box.show();
                else {$box.hide();}
            });
        }
        
        if (e.keyCode == 13) e.preventDefault();
        return false;
    },
    ddQuickShift: false,
    quickShift: {},
    outsideClickListener: (event) => {
        var selector = "td.open, #quickShift";
        $target = $(event.target);
        if (!$target.closest(selector).length) {
            lx.roster.ddClose();
        }
    },
    ddDepToggle: () => {
        let $c = $("#dep");
        let open = $c.hasClass("open");
        if (open) {
            $c.removeClass("open");
        } else {
            $c.addClass("open");
        }
    },
    ddCycleToggle: () => {
        let $c = $("#cycle");
        let open = $c.hasClass("open");
        if (open) {
            $c.removeClass("open");
        } else {
            $c.addClass("open");
        }
    },
    ddYearToggle: () => {
        let $c = $("#year");
        let open = $c.hasClass("open");
        if (open) {
            $c.removeClass("open");
        } else {
            $c.addClass("open");
        }
    },
    ddClose: () => {
        $("#roster td.open, #quickShift").removeClass("open").find("#shiftDD").remove();
        document.removeEventListener('click', lx.roster.outsideClickListener);
    },
    ddOpen: (e, pQuickShift) => {
        let $td = $(e.currentTarget);
        if ($td.hasClass("add")){
            $td = $td.closest("td");
            lx.roster.shiftAdd = true;
        }
        if ($td.hasClass("open") || $td.hasClass("disabled") || $td.find(".recRepeat").length > 0) {
            lx.roster.ddClose();
            return;
        }
        lx.roster.ddClose();
        if (!pQuickShift && lx.roster.ddQuickShift) {
            lx.roster.shiftSet(e.currentTarget, true);
            return;
        }
        $td.addClass("open");
        if (pQuickShift) $td.append(lx.roster.shiftDD);
        else $td.find(".recs").append(lx.roster.shiftDD);
        $("#shiftDD tbody tr").click((e) => {lx.roster.shiftSet(e.currentTarget); e.stopPropagation();});
        $("#shiftDD tbody td.home").click((e) => {lx.roster.shiftSet(e.currentTarget); e.stopPropagation();});
        document.addEventListener('click', lx.roster.outsideClickListener);
        if (lx.roster.shiftType) {
            $td.find("#shiftDD tr[data-adtcode!="+ lx.roster.adtCode +"]").hide();
            if (lx.roster.adtCode != 'TS'){
                $td.find("#shiftDD tr[data-type!="+ lx.roster.shiftType +"]").hide();
            }
        }
    },
    shiftRemove: function (pThis, pNoToggle, pNoVerify) {
        let $rec = $(pThis).closest('.rec');
        let $tr = $rec.closest("tr");
        let actual = $rec.hasClass('actual');
        let confirmable = pNoVerify || $rec.closest("tr").hasClass("confirmable");
        
        if (actual && !confirmable){
            lx.roster.recChange($rec);
            $rec.toggleClass("deleteReq");
        } else if ($rec.hasClass("deleteReq") && !confirmable) { return;
        } else if ( !pNoToggle && $rec.hasClass("deleted") ) $rec.removeClass("deleted");
        else if ( $rec.data("id") ) {
            lx.roster.recChange($rec);
            $rec.addClass("deleted");
            // no need to verify rest of the document if the user is manager and can confirm records
            if (confirmable || !actual) $rec.addClass("noVerify");
        } else $rec.remove();
        //lx.btn.hightlight("saveRoster");
        lx.roster.setHeights($tr);
    },
    shiftRemoveAll: function (pThis) {
        $(pThis).closest("tr").find(".rec").each( function (idx, el) { lx.roster.shiftRemove(el)} );
    },
    shiftApprove: (pThis) => {
        let $rec = $(pThis).closest('.rec');
        if ($rec.hasClass("deleteReq")) $rec.removeClass("deleteReq").addClass("deleted");
        else $rec.removeClass("reject rejected").addClass("confirm");
        lx.roster.recChange($rec);
        /*if ($rec.data("adtcode") == "VLR") {
            let start = Number($rec.attr("data-start"));
            let end   = Number($rec.attr("data-end"));
            $rec.closest(".recs").find(".rec[data-adtcode=TS]").each(function () {
                if (start <= this.dataset.start && end >= this.dataset.end){
                    console.log("remove because same hours selected")
                    lx.roster.shiftRemove($(this), true, true);
                } 
                // logic moved to pkg_shift.submit
                //else if (start > this.dataset.start && end < this.dataset.end) {
                    lx.roster.hoursElement = $(this);
                    let shift = lx.roster.getShift(null,'TS');
                    shift.start = end;
                    shift.end   = this.dataset.end;
                    // set first part
                    lx.roster.hoursSet(null, {"end":start});
                    // add second part
                    lx.roster.shiftSetP($(this), shift);
                } else if (start >= this.dataset.start  && start < this.dataset.end) {
                    lx.roster.hoursElement = $(this);
                    lx.roster.hoursSet(null, {"start":end});
                } else if (end <= this.dataset.end  && end > this.dataset.start) {
                    lx.roster.hoursElement = $(this);
                    lx.roster.hoursSet(null, {"end":start});
                }
            });
        }*/
    },
    requestMode: (pRec) => {
        let $emp = pRec.closest(".emp");
        if (!$emp.next().hasClass("empRequest")){
            const srd = lx.roster.signRequestDetails;
            const minSig = srd.minSig;
            let signSelected = [];
            let signeeLov = '';
            for (let i = 0; i < srd.signeeLov.length; i++) {
                const emp = srd.signeeLov[i];
                if (i < minSig) signSelected.push(emp.id);
                signeeLov += '<option value="'+ emp.id +'">'+ emp.name +'</option>';
            }
            signeeLov = '<select class="selectlist apex-item-select" size="1" multiple>'+ signeeLov + '</select>';//signee 
            let rowHtml = signeeLov;
            if (signSelected.length == 0) {
                rowHtml = rowHtml.replace('value="'+ srd.signeeLov[0].id +'"', 'value="'+ srd.signeeLov[0].id +'" selected');
            } else {
                for (let j = 0; j < signSelected.length; j++) {
                    const sig = signSelected[j];
                    rowHtml = rowHtml.replace('value="'+ sig +'"', 'value="'+ sig +'" selected');
                    //console.log(sig);
                }
            }
            $emp.after('<tr class="empRequest" data-eid="'+ $emp.data("id") +'"><td></td><td colspan="'+ (lx.roster.data.duration + 3) +'">'+
                        '<div class="signees"><label>'+ lx.tran.get('SEND_REQUEST_TO') +':</label>'+ rowHtml + '</div>'+
                        '<textarea maxlength="4000" class="requestNote textarea apex-item-textarea" placeholder="'+ lx.tran.get('NOTE') +'"></textarea>'+
                    '</td></tr>');
            lx.roster.sendToSigChoice = new Choices('.empRequest select', {removeItemButton:true,allowHTML:true});
        }
    },
    rejectMode: (pRec) => {
        let $emp = pRec.closest(".emp");
        if (!$emp.next().hasClass("empReject"))
            $emp.after('<tr class="empReject" data-eid="'+ $emp.data("id") +'"><td></td><td colspan="'+ (lx.roster.data.duration+3) +'">'+
                        '<textarea maxlength="4000" class="rejectNote textarea apex-item-textarea" placeholder="Reject note"></textarea>'+
                    '</td></tr>');
    },
    shiftReject: (pThis) => {
        let $rec = $(pThis).closest('.rec');
        if ($rec.hasClass("deleteReq")) $rec.removeClass("deleteReq").addClass("confirm");
        else $rec.removeClass("actual confirm").addClass("reject");
        lx.roster.rejectMode($rec);
        lx.roster.recChange($rec);
    },
    shiftApproveAll: function (pThis, pBulk) {
        $(pThis).closest("tr").find(".rec").not(".actual").each( function (idx, el) { lx.roster.shiftApprove(el)} );
        if (!pBulk) lx.roster.submit();
    },
    shiftApproveGlobal: function (pThis) {
        $("tr.emp.confirmable").find(".rec").not(".actual").not(".confirm").each( function (idx, el) { lx.roster.shiftApprove(el)} );
        lx.roster.submit();
    },
    recChange: (pEl) => {
        let confirmable = $(pEl).closest('tr.emp').hasClass("confirmable");
        lx.btn.hightlight("saveRoster");
        if (pEl.hasClass("actual")) pEl.removeClass("actual");
        if (confirmable) pEl.addClass("confirm");
        else lx.roster.requestMode(pEl);
        pEl.closest("td").addClass("changed");
        pEl.closest(".emp").addClass("changed");
    },
    hourCnt: (start,end) => {
        if(start == -1) return 0;
        let hrs = (start < end ? end : (end+1440) ) - start;
        if (hrs != 0) hrs = Math.round( (hrs / 60)*100)/100;
        return hrs;
    },
    hoursElement: null,
    hoursSet: (pThis, pSet) => {
        if ((pThis && pThis.id == 'hoursSet') || pSet) {
            let $rec = lx.roster.hoursElement;//$(pThis).closest('.rec');
            $rec.removeClass("actual confirm reject rejected");
            let start, end;
            if (pSet) {
                start = $nvl(pSet.start, $rec.attr("data-start") );
                end   = $nvl(pSet.end  , $rec.attr("data-end") );
            } else {
                start = Number($v("rosterStartHrs"));
                end = Number($v("rosterEndHrs"));
            }
            $rec.attr('data-start', start);
            $rec.attr('data-end',   end);
            let hrs = lx.roster.hourCnt(start,end);
            $rec.find("hrs").text( hrs );
            $rec.find("shift").html( lx.roster.data.timeLov[start] +'<br/>'+ lx.roster.data.timeLov[end] );
            // Change TS record to custom shift if hours change
            if ($rec.data("adtcode") == 'TS'){
                const shiftId = $v("rosterShiftHrs");
                let shift = (shiftId == 0 ? {"code":'C'} : lx.roster.getShift(shiftId, 'TS') );
                $rec.attr('data-shift', shiftId);
                $rec.find("shiftcode").text(shift.code);
                if (shift.colorBg && shift.colorBg != 'undefined') {
                    $rec.css("background-color", shift.colorBg);
                    if (shift.colorTxt) $rec.css("color", shift.colorTxt);
                } else {
                    $rec.css("background-color",'');
                    $rec.css("color",'');
                }
            }
            // if it can be confirmed, approve it right away
            if ($rec.closest('tr').hasClass("confirmable")) lx.roster.shiftApprove($rec.find(".approve")[0]);
            else lx.roster.recChange(lx.roster.hoursElement);
            
            lx.roster.setHeights( $rec.closest('tr') );
        }
        $(".editHours").remove();
        //lx.roster.hoursElement = null;
    },
    hoursShiftChange: (e) => {
        let $shift = $("#rosterShiftHrs");
        let $start = $("#rosterStartHrs");
        let $end   = $("#rosterEndHrs");
        if (e.target.id == "rosterShiftHrs"){
            for (let i = 0; i < lx.roster.data.shifts.length; i++) {
                const s = lx.roster.data.shifts[i];
                if (s.adtCode == 'TS' && s.id == $shift.val()){
                    $start.val(s.start);
                    $end.val(s.end);
                    break;
                }
            }
        } /*else {
            let start = $start.val();
            let end   = $end.val();
            let shiftFound = false;
            for (let i = 0; i < lx.roster.data.shifts.length; i++) {
                const s = lx.roster.data.shifts[i];
                if (s.adtCode == 'TS' && start == s.start && end == s.end){
                    $shift.val(s.id);
                    shiftFound = true;
                    break;
                }
            }
            if (!shiftFound) $shift.val(0);
        }*/
        //let $start = $("")
    },
    hoursEdit: (pThis) => {
        let html = '', startLov = '', endLov = '', shiftLov = '';
        $(".editHours").remove();
        let $rec = $(pThis).closest(".rec");
        let adtCode = $rec.data("adtcode");
        if (adtCode == 'VLR' && $rec.hasClass("recRepeat") ) {
            lx.roster.documentForm(null,null,$rec.data("id"));
            return;
        }
        lx.roster.hoursElement = $rec;
        let start = Number($rec.attr('data-start'));
        let end   = Number($rec.attr('data-end'));
        // Hour lovs
        Object.keys(lx.roster.data.timeLov).forEach( function (key) { 
            //if (key%30 == 0){ commented on 9.4.2026 by Davor: we started using 15 and 45 min
                if (key != 1440) startLov += '<option value="'+ key + '"'+ (start == key ? ' selected' : '') +'>'+ lx.roster.data.timeLov[key] +'</option>';
                if (key != 0) endLov += '<option value="'+ key + '"'+ (end == key ? ' selected' : '') +'>'+ lx.roster.data.timeLov[key] +'</option>';
            //}
        });
        // Shift lov
        for (let i = 0; i < lx.roster.data.shifts.length; i++) {
            const s = lx.roster.data.shifts[i];
            if (s.adtCode == 'TS')
                shiftLov += '<option value="'+ s.id + '"'+ (start == s.start && end == s.end ? ' selected' : '') +'>'+ s.code +' - '+ s.name +'</option>';
        }
        html = '<div class="editHours"><table>'+
                (adtCode != 'OH' ? '<tr><td colspan="2"><select id="rosterShiftHrs"><option value="0">C - '+ lx.tran.get("CUSTOM") +'</option>'+ shiftLov +'</select></td></tr>' : '') +
                '<tr>'+'<td><select id="rosterStartHrs">'+ startLov +'</select></td>'+
                '<td><select id="rosterEndHrs">'+ endLov +'</select></td></tr>'+
                '<tr>'+'<td>'+ lx.btn.gen({"id":"hoursSet","label":lx.tran.get("APPLY_CHANGES"),"fa":"far fawe-save","js":"lx.roster.hoursSet(this);"}) +'</td>'+
                '<td>'+ lx.btn.gen({"id":"hoursCancel","label":lx.tran.get("CANCEL_BTN"),"fa":"far fawe-times","js":"lx.roster.hoursSet(this);"}) +'</td></tr>'+
               '</table></div>';
        $rec.closest("td").append(html);
        $(".editHours").change( function (e) {
            lx.roster.hoursShiftChange(e);
        });/**/
    },
    toggleWorkFrom: (pThis) => {
        let $el = $(pThis);
        if ($el.hasClass("fawe-building")) $el.removeClass("fawe-building").addClass("fawe-home");
        else $el.removeClass("fawe-home").addClass("fawe-building");
        lx.roster.recChange( $el.closest(".rec") );
    },
    shiftSetP: (pEl, shift, row) => {
        //console.log(pEl);
        //console.log(row);
        //console.log(shift);
        let $recs = pEl.find(".recs");
        let $tr = $recs.closest('tr');
        let eTS = $tr.hasClass("eTS");
        let eVLR = $tr.hasClass("eVLR");
        let eOH = $tr.hasClass("eOH");
        let offDay = $recs.closest('td').hasClass("rsrOffDay");
        let editable = $tr.hasClass("e"+(row ? row.adtCode : shift.adtCode) );//$tr.hasClass("editable");
        if (editable && offDay && !row && shift.adtCode == "VLR") return;
        let confirmable = $tr.hasClass("confirmable");
        let approved = false;
        let removeOld = true;
        if (!row && !editable) return;
        
        if (lx.roster.shiftAdd) {
            lx.roster.shiftAdd = false;
            removeOld = false;
            console.log("shiftAdd");
        } 
        if (editable && !row && (!shift || shift.id == -2) ) {
            if (removeOld)
                $recs.find(".rec").each( function (idx, el) { lx.roster.shiftRemove(el); } );
        } else {
            let lActual = (row && row.confirmedBy);
            let lRejected = (lActual && row.startA == row.endA);
            if (!row){
                // existing TS row in the day
                let $ts = $recs.find(".rec[data-adtcode=TS]");
                if ($ts.length > 0){
                    console.log("$ts.length > 0");
                    if (shift.adtCode == 'TS' && removeOld){
                        console.log("allow only one TS per day");
                        // allow only one TS per day
                        lx.roster.shiftRemove($ts, true);
                    } else if (shift.adtCode == 'VLR') {
                        console.log("set start and end of VLR to existing TS");
                        // set start and end of VLR to existing TS
                        shift.start = Number( $ts.attr("data-start") );
                        shift.end   = Number( $ts.attr("data-end") );
                    } else if (shift.adtCode == 'OH') {
                        console.log("set overtime start at the end of existing TS");
                        // set overtime start at the end of existing TS
                        shift.start = Number( $ts.attr("data-end") );
                        shift.end   = shift.start + 60;
                    }
                } else if (shift.adtCode == 'VLR') {
                    console.log("shift.adtCode == 'VLR', type=" + shift.type);
                    if (shift.type == 'S' || shift.type == 'D') {
                        // whole day (Suspension & detachements)
                        shift.start = 0;
                        shift.end   = 1440;
                    } else if (shift.type == 'M4') {
                        // get default shift
                        let defShift = lx.roster.data.shifts.filter((s)=> s.def == 'Y' )[0];
                        shift.start = defShift.start;
                        shift.end   = defShift.start+(4*60);
                    } else {
                        // get default shift
                        let defShift = lx.roster.data.shifts.filter((s)=> s.def == 'Y' )[0];
                        shift.start = defShift.start;
                        shift.end   = defShift.end;
                    }
                }
                // allow only one VLR request per day
                if (shift.adtCode == 'VLR' && removeOld) {
                    lx.roster.shiftRemove($recs.find(".rec[data-adtcode=VLR]")[0], true);
                }
            }
            // box styling
            let style = '';
            let shiftClass = '';
            if (shift.colorBg && shift.colorBg != 'undefined') {
                if (shift.colorTxt) style = 'color:'+ shift.colorTxt+';';
                style += 'background-color:'+ shift.colorBg +';';
            } else if (shift.class && shift.class != "undefined") shiftClass = ' lx_hr_type_'+ shift.class;
            // multiple days box
            let repeats = row && row.repeat;
            if (repeats) {
                shiftClass += ' recRepeat';
                style += 'width: calc('+ row.repeat +' * (100% + 1px));';
            }
            // hours
            let start, end;
            if (row) {
                start = (lActual && !lRejected ? row.startA : row.start);
                end   = (lActual && !lRejected ? row.endA : row.end);
            }else{
                start = shift.start;
                end   = shift.end;
            }
            let hrs = lx.roster.hourCnt(start,end);
            // record html
            let html = '<div class="rec'+ (editable ? '' : ' readonly') + (lRejected ? ' rejected' : (lActual ? ' actual' : '')) + 
                                shiftClass + (row && row.deleteReq ? ' deleteReq' : '') +
                                (lx.roster.docId ? ' highlight' : '') +
                                (style ? '" style="'+style : '') +'" title="'+ shift.name +
                                (row && row.rId ? '" data-id="'+row.rId +'" data-docid="'+row.id : (lx.roster.docId ? '" data-docid="'+ lx.roster.docId : ''))+ 
                                '" data-shift="'+ (shift.id?shift.id:0) +
                                '" data-adtcode="'+ shift.adtCode +
                                '" data-type="'+ shift.type +
                                '" data-start="'+ start +
                                '" data-end="'+ end +
                                '" data-oncall="'+ shift.onCall +
                                //(row && row.repeat ? '" style="position: absolute;width: calc('+ row.repeat +' * (100% + 1px));z-index: 1;' : '')+
                                '">'+ 
                            (shift.adtCode == 'TS' && (shift.workFrom != 'N' || (row && row.workFrom == 'H')) ? '<i class="workFrom fas fawe-'+ (row && row.workFrom == 'H' || !row && shift.workFrom == 'H' ? 'home' : 'building') +
                                                                              '" title="'+ lx.roster.data.workFrom.W +' / '+ lx.roster.data.workFrom.H +'"></i>' : '')+
                            (shift.onCall == 'Y' ? '<i class="onCall fas fawe-phone"></i>' : '')+
                            '<hrs>'+ hrs +'</hrs>' + 
                            '<span>?</span>'+
                            '<shiftcode>'+ (repeats ? shift.name + (row.detachedTo ? ': '+row.detachedTo : '') : shift.code) +'</shiftcode>'+
                            //'<shiftcode>'+ shift.code +'</shiftcode>'+
                            (repeats ? '<shift style="width:100%">'+ lx.roster.data.timeLov[start] +' - '+ lx.roster.data.timeLov[end] +'</shift>' : 
                                       '<shift>'+ lx.roster.data.timeLov[start] +'<br/>'+ lx.roster.data.timeLov[end] +'</shift>')+
                            (editable ? '<div class="shiftBtns">'+ 
                            '<div class="remove" title="'+ lx.tran.get('REMOVE') +'"><i class="far fawe-trash"></i></div>'+
                            (shift.adtCode == 'VLR' && (shift.type == 'D' || shift.type == 'S') ? '<div class="edit editDoc" title="Edit document"><i class="far fawe-edit"></i></div>' : 
                                '<div class="edit" title="'+ lx.tran.get("CHANGE") +'"><i class="far fawe-clock"></i></div>'+
                                (confirmable ?  '<div class="approve" title="'+ lx.tran.get("APPROVE") +'"><i class="far fawe-check"></i></div>'+
                                                '<div class="reject" title="'+ lx.tran.get("REJECT") +'"><i class="far fawe-times"></i></div>' : '') ) +
                            //(row ? '<div class="info" title="Info"><i class="far fawe-info"></i></div>' : '')+
                            '<div class="add" title="'+ lx.tran.get('ADD') +'"><i class="far fawe-plus"></i></div>'+
                            '</div>' : '')+
                        '</div>';
            let $rec;
            if (shift.adtCode == 'TS') {
                $recs.prepend(html);
                $rec = $recs.find(".rec:first-child");
            } else {
                $recs.append(html);
                $rec = $recs.find(".rec:last-child");
            }
            if (editable) {
                if (shift.adtCode == 'TS') $rec.find(".workFrom").click("click", function (e) {e.stopPropagation();lx.roster.toggleWorkFrom(e.currentTarget);} );
                $rec.find(".remove" ).click("click", function (e) {e.stopPropagation();lx.roster.shiftRemove( e.currentTarget);} );
                $rec.find(".edit"   ).click("click", function (e) {e.stopPropagation();lx.roster.hoursEdit(e.currentTarget);} );
                $rec.click("click", function (e) {e.stopPropagation();lx.roster.docInfo(e.currentTarget);} );//.find(".info"   )
                $rec.find(".add"    ).click("click", function (e) {e.stopPropagation();lx.roster.ddOpen(e);} );
                if (confirmable) {
                    $rec.find(".reject").click("click", function (e) {e.stopPropagation();lx.roster.shiftReject(e.currentTarget);} );
                    let $approve = $rec.find(".approve");
                    $approve.click("click", function (e) {e.stopPropagation();lx.roster.shiftApprove(e.currentTarget);} );
                    // if it can be confirmed, approve it right away
                    if (!row){
                        lx.roster.shiftApprove($approve[0]);
                        // set the approved flag so recChange is not executed twice
                        approved = true;
                    }
                }
            }
            // handle floating repeating box height
            if (!row) {
                lx.roster.setHeights($tr);
                /*let recHeight = $rec[0].offsetHeight;
                let trHeight = $tr[0].offsetHeight;
                if (trHeight < recHeight) $tr.css("height", recHeight+'px');
                else $rec.css("min-height", trHeight+'px');*/
            }
        }
        // set flag that record is changed and needs to be submited
        if (!row && !approved) {
            lx.roster.recChange($recs);
        }
    },
    setHeights: (tr) => {
        let $tr = tr;
        if (!tr) $tr = $('#roster tr.emp');
        else {
            // TS
            let totalHrs = 0;
            $tr.find(".rec[data-adtcode=TS]:not(.deleted,[data-oncall=Y]) hrs").each(function () {
                let hrs = parseFloat(this.textContent);
                totalHrs += hrs;
            });
            $tr.find('td.total .ts').text( Math.round(totalHrs*100)/100 );
            // VLR
            totalHrs = 0;
            $tr.find(".rec[data-adtcode=VLR]:not(.deleted) hrs").each(function () {
                let hrs = parseFloat(this.textContent);
                totalHrs += hrs;
            });
            $tr.find('td.total .vlr').text( Math.round(totalHrs*100)/100 );
            // OH
            totalHrs = 0;
            $tr.find(".rec[data-adtcode=OH]:not(.deleted) hrs").each(function () {
                let hrs = parseFloat(this.textContent);
                totalHrs += hrs;
            });
            $tr.find('td.total .oh').text( Math.round(totalHrs*100)/100 );
        }
        $tr.each(function(){
            let maxHeight = 0;
            $tr = $(this);
            $tr.find('.recs,.recRepeat').each(function(){
                var thisH = this.offsetHeight;
                if (thisH > maxHeight) { maxHeight = thisH; }
            });
            if (this.offsetHeight > maxHeight) maxHeight = this.offsetHeight;
            $tr.css("height", maxHeight+'px');
            $tr.find('.recRepeat').css("min-height", maxHeight+'px');
        });
    },
    shiftSet: (pThis, pQuick) => {
        let $shift = $(pThis);
        let fromHome = false;
        if ($shift.hasClass("home")) {
            $shift = $shift.closest("tr");
            fromHome = true;
        }
        let $td = (pQuick ? $(pThis) : $shift.closest('td.open, #quickShift') );
        let shift = (pQuick ? lx.roster.quickShift : lx.roster.getShift($shift.data("id"), $shift.data("adtcode"), $shift.data("type")) );
        if (fromHome) shift.workFrom = 'H';
        else if (!pQuick && shift.workFrom != 'N') shift.workFrom = 'W';
        let quickShiftSelection = $("#quickShift.open").length > 0;
        lx.roster.ddClose();

        if (!pQuick && quickShiftSelection) {
            lx.roster.quickShift = shift;
            if (shift.id == -1) {
                lx.roster.clearQuickShift();
            } else {
                //let style = '';
                // reset styling
                $td.css("background-color","").css("color","").removeClass(function (index, css) {
                    return (css.match (/\blx_hr_type_\S+/g) || []).join(' '); // removes anything that starts with "lx_hr_type_"
                });
                // set styling
                if (shift.colorBg && shift.colorBg != 'undefined') {
                    if (shift.colorTxt) $td.css("color",shift.colorTxt); else $td.css("color",'');//style = ';color:'+ shift.colorTxt;
                    $td.css("background-color",shift.colorBg);
                    //style = '" style="background-color:'+ shift.colorBg + style;
                } else if (shift.class && shift.class != "undefined") $td.addClass('lx_hr_type_'+ shift.class);//style = ' lx_hr_type_'+ shift.class;
                // set name and code
                $td.find(">span").html(" | "+ (shift.code ? shift.name +' - <div class="quickShift'+ /*style +*/'">'+ shift.code +'</div>' : "Clear" ) );
                $td.addClass("selected");
                $td.find(".workFrom").remove();
                if (shift.adtCode == 'TS' && shift.workFrom != 'N') {
                    $td.append('<i class="workFrom fas fawe-'+ (shift.workFrom == 'H' ? 'home' : 'building') +'"></i>');
                }
                lx.roster.ddQuickShift = true;
            }
            return;
            //$td = $td.find(".quickShift");
        }
        if (shift.adtCode == 'TS') {
            $rec = $td.closest('tr').find('.rec[data-adtcode=TS]');
            console.log($rec);
            if ($rec.length > 0 && lx.roster.docId == null ) lx.roster.docInfo($rec[0]);
        }
        if (shift.adtCode == 'VLR' && (shift.type == 'D' || shift.type == 'S')) lx.roster.documentForm($td, shift);
        else lx.roster.shiftSetP($td, shift);
    },
    clearQuickShift: () => {
        $td = $('#quickShift');
        lx.roster.ddQuickShift = false;
        $td.find(">span").html('');
        $td.removeClass("selected").css("color",'').css("background-color",'').removeClass(function (index, css) {
            return (css.match (/\blx_hr_type_\S+/g) || []).join(' '); // removes anything that starts with "lx_hr_type_"
       });
       $td.find(".workFrom").remove();
    },
    setCycle: (pDate) => {
        if ($(".emp.changed").length > 0) {
            lx.roster.submit(pDate);
        } else {
            $s('P157_DATE', pDate);
            lx.roster.fetch(pDate);
        }
        lx.roster.closeDoc();
    },
    getOut: (deps, pOutId) => {
        let dep = null;
        if (pOutId == 0) return deps;
        for (let i = 0; i < deps.length; i++) {
            const d = deps[i];
            if (d.id == pOutId) return d;
            else if (d.deps.length > 0) dep = lx.roster.getOut(d.deps, pOutId);

            if (dep) return dep;
        }
        return null;
    },
    setOutId: (pOutId, pThis) => {
		lx.roster.rptOutId = pOutId;
        let dep = (pOutId == 0 ? lx.roster.data.deps : [lx.roster.getOut(lx.roster.data.deps, pOutId)] );
        //console.log(dep);
        let deps = lx.roster.renderDep(dep, null);
        let $dep = $("#dep");
        
        $("#roster > table > tbody").html(deps.html);
        lx.roster.setData();
        $(".emp.editable td:not(:first-child)").click( (e) => { if ($(e.target).closest(".editHours").length == 0) lx.roster.ddOpen(e); } );
        if (pOutId == 0) {
            $dep.find("> span").text( lx.roster.loc.filterDep );
            $dep.removeClass("selected");
            setTimeout( () => {if ($dep.hasClass("open")) lx.roster.ddDepToggle();}, 100);
        } else {
            $dep.find("> span").text( $(pThis).find('td:first-child').text() );
            $dep.addClass("selected");
        }
        
    },
    /*getEmpRecs: (adtCode) => {
        let emps = $(".emp.changed.chg"+ adtCode).map((idx, el) => { 
            let shifts = $(el).find("td[data-adtcode="+ adtCode +"]").map( (idx,el) => {
              if (el.className != 'emp' && el.dataset.shift)
                return {"date": el.dataset.date, "shift": el.dataset.shift };
              else return;
            } ).get();
            let rows = {};
            for (const key in shifts) {
                if (Object.hasOwnProperty.call(shifts, key)) {
                    const row = shifts[key];
                    if (!rows[row.shift]) rows[row.shift] = [];
                    rows[row.shift].push(row.date);
                }
            }
            return JSON.stringify( {"id": el.dataset.id, "shifts": Object.keys(rows).map( (key) => {return {id: key, dates: rows[key]} }) }); 
            //return JSON.stringify( {"id": el.dataset.id, "shifts": shifts} ); 
        }).get();
        return emps;
    },*/
    getEmpRequests: () => {
        let emps = $(".emp.changed").map((idx, el) => { 
            let dates = [];
            $(el).find("td.changed").each( function (idx) {//:gt(1)
               let rows = [];
                $(this).find(".rec").not(".actual").each( function (i) {//.not(".deleted")
                    rows.push({ "id":this.dataset.id,"docId":$nvl(this.dataset.docid,0),"adtCode":this.dataset.adtcode,
                                "shift":$nvl(this.dataset.shift,0),
                                "start":this.dataset.start,"end":this.dataset.end,
                                "workFrom": ($(this).find(".workFrom").hasClass('fawe-home') ? 'H' : 'W'),
                                "confirm":$(this).hasClass("confirm"),"reject":$(this).hasClass("reject"),
                                "delete":$(this).hasClass("deleted"),
                                "deleteReq":$(this).hasClass("deleteReq"),
                                "noVerify":$(this).hasClass("noVerify")});
                });
                if (rows.length > 0 ) dates.push({"date":this.dataset.date,"rows":rows});
            } );
            let rejectNote, requestNote, requestEmps;
            if ($(el).next().hasClass("empReject"))
                rejectNote = $(".empReject[data-eid="+ el.dataset.id +"] .rejectNote").val();
            //empRequest
            if ($(el).next().hasClass("empRequest")){
                requestNote = $(".empRequest[data-eid="+ el.dataset.id +"] .requestNote").val();
                requestEmps = lx.roster.sendToSigChoice.getValue(true);//.join(":")
            }
            return JSON.stringify( {"id": el.dataset.id, "dates": dates, "rejectNote": rejectNote, "requestNote": requestNote, "requestEmps": requestEmps }); 
            //return JSON.stringify( {"id": el.dataset.id, "shifts": shifts} ); 
        }).get();
        return emps;
    },
    submit: (pFetchDate, pSendToSigEl) => {
        lx.load.add();
        apex.server.process(
            "rosterSubmit",
            {
                x01: lx.roster.data.id,
                f01: lx.roster.getEmpRequests()/* ,
                f02: $("#roster .rec.deleted").map((idx,el) => { return el.dataset.id; }).get() */
            },{
                success: function (d) {
                    lx.load.remove();
                    if (d.err) alert(d.err);
                    else {
                        lx.roster.closeDoc();
                        lx.btn.unhightlight("saveRoster");
                        let $empChanged = $(".emp.changed");
                        $empChanged.removeClass("changed");
                        $empChanged.find("td.changed").removeClass("changed");
                        //$(".emp .rec.deleted").remove();
                        let msg = [d.msg];//"Saved changes for "+ d.emps.length +" employee(s)"
                        if (d.emps && d.emps.length > 0)
                            for (let i = 0; i < d.emps.length; i++) {
                                const emp = d.emps[i];
                                lx.roster.setEmpData(emp.id, emp.docs, true);
                                if (emp.clearRejectNote) $(".empReject[data-eid="+ emp.id +"]").remove();
                                if (emp.clearReqNote) $(".empRequest[data-eid="+ emp.id +"]").remove();
                                msg.push(emp.name + '<br />'+ emp.notifMsg);
                            }
                        if (pFetchDate) lx.roster.setCycle(pFetchDate);
                        else if (pSendToSigEl) lx.roster.sendToSig(pSendToSigEl);
                        lx.info.success(msg.join("<br />"));
                    }
                }/*,
                complete: function(jqXHR, textStatus) {   
                    self.submitRequested = false;
                }*/
            });
    },
    editEmp: (pThis) => {
        let pId = $(pThis).closest('tr.emp').attr('data-id');
        apex.server.process("editEmp",{x01: pId},{
            success: function (d) {
                if (d.err) lx.info.error(d.err);
                else if (d.link) lx.nav.redirect(d.link, true);
            }
        });
    },
    documentForm: (pThis, pShift, pRecId) => {
        let pId = $(pThis).closest('tr.emp').attr('data-id');
        let date = $(pThis).data('date');
        //console.log(date);
        apex.server.process("documentForm",{x01: (pRecId ? pRecId : null), x02: pId, x03: date, x04: (pShift ? pShift.type : null)},{
            success: function (d) {
                if (d.err) lx.info.error(d.err);
                else if (d.js) eval(d.js);
            }
        });
    },
    report: () => {
        let tab = $("#roster").find('.rsrHdr .is-active[aria-controls]').attr('aria-controls');
		let year = $("#roster").find('.rsrHdr #yearDD .current td').text();
		let cycleFrom = $("#roster").find('.rsrHdr #cycleDD .current td:nth-child(2)').text();
		let cycleTo = $("#roster").find('.rsrHdr #cycleDD .current td:nth-child(3)').text();
		let outId = lx.roster.rptOutId;
		let term = lx.roster.rptSearch;
		let params = tab + "~" + year + "~" + cycleFrom + "~" + cycleTo + "~" + outId + "~" + term + "~";
		console.log(params);
		lx.report.run('ROSTER', params,'gen');
    }
};